import { Form } from 'antd'
import { Props } from '.'
import { reducer, initialState, setPreviewModalOptionAction } from './reducer'
import { useReducer } from 'react'

export function useSetupHook(props: Props) {
  const { src } = props
  const [form] = Form.useForm()
  const [state, dispatch] = useReducer(reducer, initialState)
  const { previewModalOption } = state
  const cancelPreviewModal = () => {
    dispatch(
      setPreviewModalOptionAction({
        ...previewModalOption,
        open: false,
      }),
    )
  }
  const showPreviewModal = () => {
    dispatch(
      setPreviewModalOptionAction({
        open: true,
        fileUrl: src ?? '',
      }),
    )
  }
  return {
    state,
    form,
    cancelPreviewModal,
    showPreviewModal,
  }
}
import { Form } from 'antd'
import { Props } from '.'
import { reducer, initialState, setPreviewModalOptionAction } from './reducer'
import { useReducer } from 'react'

export function useSetupHook(props: Props) {
  const { src } = props
  const [form] = Form.useForm()
  const [state, dispatch] = useReducer(reducer, initialState)
  const { previewModalOption } = state
  const cancelPreviewModal = () => {
    dispatch(
      setPreviewModalOptionAction({
        ...previewModalOption,
        open: false,
      }),
    )
  }
  const showPreviewModal = () => {
    dispatch(
      setPreviewModalOptionAction({
        open: true,
        fileUrl: src ?? '',
      }),
    )
  }
  return {
    state,
    form,
    cancelPreviewModal,
    showPreviewModal,
  }
}
